<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<div
    class="tw-pt-[7rem] tw-pb-[5rem] tw-max-w-[1300px] tw-mx-auto tw-px-[20px]"
>
    <div
        *ngIf="isSearched"
        class="tw-flex tw-gap-[5px] tw-font-semibold tw-text-[#7B7575] tw-mb-[20px]"
    >
        <span (click)="goBack()" class="tw-uppercase tw-cursor-pointer"
            >FAQ</span
        >
        <span>/</span>
        <span class="tw-capitalize tw-text-black">{{
            selectedLanguage === "en" ? categoryNameEn : categoryNameBm
        }}</span>
    </div>
    <div
        class="tw-flex tw-flex-col tw-gap-[20px] tw-mb-[50px] tw-w-full"
        [ngClass]="isSearched ? ' tw-items-start' : ' tw-items-center'"
    >
        <div
            class="tw-text-[24px] tw-text-[#212121] tw-font-bold lg:tw-font-semibold"
        >
            {{ "COMMON.HOW_CAN_WE_HELP?" | translate }}
        </div>
        <div class="tw-max-w-[95%] md:tw-max-w-[50%] tw-relative tw-w-full">
            <div
                class="tw-h-[56px] tw-flex tw-flex-1 tw-content-center tw-gap-3 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-p-[18px] tw-bg-white"
            >
                <mat-icon fontIcon="search" class="tw-text-black" />
                <input
                    class="tw-flex-1 tw-font-semibold"
                    placeholder="{{ 'FAQ.SEARCH' | translate }}"
                    (keydown.enter)="displaySearchResults()"
                    [(ngModel)]="searchKeyword"
                    (keyup)="searchContent(searchKeyword)"
                />
                <mat-icon
                    (click)="clearSearch()"
                    *ngIf="searchKeyword?.length > 0"
                    class="tw-text-[#D8D8D880] tw-cursor-pointer hover:tw-text-black"
                    >cancel</mat-icon
                >
            </div>
            <div
                *ngIf="searchKeyword.length > 0"
                class="search-result tw-w-full tw-bg-white tw-min-h-[50px] tw-max-h-[400px] tw-overflow-y-auto tw-absolute tw-z-[11] tw-rounded-[20px] tw-shadow-lg tw-py-[20px]"
            >
                <ul class="tw-px-[20px]">
                    <li
                        *ngFor="let item of searchResults.slice(0, 10)"
                        (click)="searchQuestion(item)"
                        class="tw-py-[15px] tw-border-b border-b-[#D8D8D8] tw-text-[18px] tw-font-[500] tw-cursor-pointer hover:tw-font-bold"
                    >
                        {{
                            selectedLanguage == "en"
                                ? item.questionEn
                                : item.questionBm
                        }}
                    </li>
                </ul>
                <p
                    *ngIf="
                        searchKeyword.length > 0 && searchResults?.length === 0
                    "
                    class="tw-text-base tw-font-semibold tw-text-caption-gray !tw-mb-0 tw-px-[20px] tw-text-[18px]"
                >
                    {{ "NEW_APPLICATION.NO_SEARCH_RESULT" | translate }}
                </p>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!isSearched">
        <div
            class="tw-grid tw-rela tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-[10px] sm:tw-gap-[24px] tw-mb-[50px]"
        >
            <div
                *ngFor="let item of filteredData"
                (click)="setCat(item)"
                class="faq-card tw-w-full tw-relative tw-min-h-[275px] sm:tw-max-w-[406px] tw-rounded-[24px] tw-flex tw-items-center tw-p-[20px] tw-cursor-pointer tw-transition-all hover:tw-shadow-lg tw-overflow-hidden"
                [style.background-color]="item.color"
            >
                <h4
                    class="!tw-mb-0 sm:tw-mb-2 !tw-text-[20px] !sm:tw-text-[24px] !tw-font-[600] !tw-relative !tw-z-10 sm:tw-max-w-[75%] !tw-break-words"
                >
                    {{
                        selectedLanguage == "en"
                            ? item.categoryEn
                            : item.categoryBm
                    }}
                </h4>
                <app-bubble
                    [classes]="'tw-absolute tw-top-[-40%] tw-right-[-40%] '"
                    [color]="item.vector"
                />
                <app-bubble
                    [classes]="'tw-absolute tw-right-[-30%] tw-bottom-[-75%] '"
                    [color]="item.vector"
                />
            </div>
            <div
                *ngIf="filteredData?.length === 0"
                class="tw-text-base tw-font-semibold tw-text-caption-gray"
            >
                {{ "NEW_APPLICATION.NO_SEARCH_RESULT" | translate }}
            </div>
        </div>
        <div
            class="tw-w-full tw-rounded-[24px] tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-between tw-gap-[20px] tw-p-[20px] tw-bg-[#95D1F33D]"
        >
            <p class="!tw-mb-0 tw-text-[#003A70] tw-text-[20px] tw-font-[700]">
                {{ "COMMON.STILL_NEED_HELP" | translate }}
            </p>
            <button
                class="tw-bg-[#003A70] tw-text-white tw-py-[16px] tw-px-[24px] tw-rounded-full tw-cursor-pointer"
                (click)="goToContactUs()"
            >
                {{ "COMMON.HELP_CONTACT" | translate }}
            </button>
        </div>
    </ng-container>
    <app-search-results
        (searchQuestion)="searchQuestion($event)"
        [searchResults]="sData"
        [selectedLanguage]="selectedLanguage"
        *ngIf="isSearched"
    ></app-search-results>
</div>

<app-footer></app-footer>
